exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu-area[data-v-0f9d31f5] {\n  margin-bottom: 20px;\n}\n.pagination-wrap[data-v-0f9d31f5] {\n  text-align: right;\n  padding: 30px 20px;\n}\n", ""]);

// exports
